/**
 * Auth0 Configuration for Stokastic Tools
 *
 * Uses the same Auth0 tenant as stokastic.com for SSO support.
 * Users logged into stokastic.com will be automatically authenticated.
 */

/**
 * Gets the base path for the current app (e.g., /lineupbuilder/, /contestgenerator/)
 * Always uses the current URL pathname to ensure correct routing after login/logout
 */
export const getAppBasePath = (): string => {
  // Always extract from current pathname (not PUBLIC_URL which is build-time only)
  const pathSegments = window.location.pathname.split('/').filter(Boolean);
  if (pathSegments.length > 0) {
    return '/' + pathSegments[0] + '/';
  }
  return '/';
};

// API audience for requesting JWT access tokens (required for cross-origin API calls)
export const auth0Audience = process.env.REACT_APP_AUTH0_AUDIENCE || 'https://api.stokastic.com';

export const auth0Config = {
  domain: process.env.REACT_APP_AUTH0_DOMAIN || 'stokastic.us.auth0.com',
  clientId: process.env.REACT_APP_AUTH0_CLIENT_ID || '',
  authorizationParams: {
    redirect_uri: window.location.origin + getAppBasePath(),
    scope: 'openid profile email',
    audience: auth0Audience,
  },
  // Must be false for cross-app SSO - enables iframe-based silent auth
  useRefreshTokens: false,
  // Store tokens in localStorage for persistence across tabs/refreshes
  cacheLocation: 'localstorage' as const,
};

export const mainSiteUrl = process.env.REACT_APP_MAIN_SITE_URL || 'https://www.stokastic.com';
